import { Card, CardContent } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import Input from 'components/forms/Input'
import Textarea from 'components/forms/Textarea'
import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import DtoCasingDeclaration from 'survey/dto/DtoCasingDeclaration'
import { hasValue } from 'utils/NumberUtil'

const PumpCard = ({
    title,
    pump,
    actions,
}) => {
    const {
        sandreCodes,
        variousMaterielTypes,
    } = useSelector((store) => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
        variousMaterielTypes: store.VariousMaterielReducer.variousMaterielTypes,
    }), shallowEqual)

    const pumpNature = variousMaterielTypes.find((t) => t.materielType === pump.materielType && t.category === 1) || {}
    const pumpCategory = sandreCodes.find((c) => c.field === 'MAT.MOBILITE' && c.code === pump.mobilityCode) || {}
    const pumpType = sandreCodes.find((c) => c.field === 'POMPES.TYPE' && c.code === pump.pumpType) || {}

    return (
        <Card
            sx={{
                border: '1px solid',
                borderColor: 'primary.main',
                borderRadius: 2,
            }}
        >
            <CardTitle title={title} color={'primary'} actions={actions} />
            <CardContent>
                <Input
                    title={i18n.name}
                    value={pump.name}
                    readMode
                />
                <Input
                    title={i18n.nature}
                    value={pumpNature.name}
                    readMode
                />
                <Input
                    title={i18n.category}
                    value={pumpCategory.name}
                    readMode
                />
                <Input
                    title={i18n.type}
                    value={pumpType.name}
                    readMode
                />
                <Input
                    title={i18n.maxFlow}
                    value={pump.maxFlow}
                    readMode
                />
                <Input
                    title={i18n.inUseFlow}
                    value={pump.operatingFlow}
                    readMode
                />
                <Input
                    title={i18n.shared}
                    value={pump.isShared ? i18n.yes : i18n.no}
                    readMode
                />
                <Input
                    title={i18n.forRent}
                    value={pump.rent ? i18n.yes : i18n.no}
                    readMode
                />
                <Input
                    title={i18n.assignmentRate}
                    value={hasValue(pump.assignmentRate) ? `${pump.assignmentRate} %` : ''}
                    readMode
                />
                <Textarea
                    title={i18n.comment}
                    value={pump.comment}
                    readMode
                />
            </CardContent>
        </Card>
    )
}

PumpCard.propTypes = {
    title: PropTypes.string.isRequired,
    pump: PropTypes.instanceOf(DtoCasingDeclaration).isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({
        onClick: PropTypes.func,
        iconName: PropTypes.string,
    })),
}

export default PumpCard
